export const ROLE_LIST_ACTION = "ROLE_LIST_ACTION";
export const ROLE_LIST_SUCCESS = "ROLE_LIST_SUCCESS";
export const ROLE_LIST_ALL_ACTION = "ROLE_LIST_ALL_ACTION";
export const ROLE_LIST_ALL_SUCCESS = "ROLE_LIST_ALL_SUCCESS";
export const ROLE_PERMISSION_LIST_ACTION = "ROLE_PERMISSION_LIST_ACTION";
export const ROLE_PERMISSION_LIST_SUCCESS = "ROLE_PERMISSION_LIST_SUCCESS";
export const ROLE_GET_UPDATE_ACTION = "ROLE_GET_UPDATE_ACTION";
export const ROLE_GET_UPDATE_SUCCESS = "ROLE_GET_UPDATE_SUCCESS";
export const ROLE_CREATE_ACTION = "ROLE_CREATE_ACTION";
export const ROLE_DELETE_ACTION = "ROLE_DELETE_ACTION";
export const ROLE_UPDATE_ACTION = "ROLE_UPDATE_ACTION";
export const ROLE_UPDATE_SUCCESS = "ROLE_UPDATE_SUCCESS";
export const ROLE_FAIL = "ROLE_FAIL";